export const routes = {
  root: "/",
  page: "/page/:pageId",
};
